import { render, staticRenderFns } from "./PanelTerniumDialog.vue?vue&type=template&id=065cfe18&"
import script from "./PanelTerniumDialog.vue?vue&type=script&lang=js&"
export * from "./PanelTerniumDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports